module.exports = __webpack_public_path__ + "static/img/keira.a5755d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/keira.png
// module id = CMD9
// module chunks = 0